import {Grid} from '@mui/material';
import {LlavesPorProducto} from '../widgets/LlavesPorProducto';
import {useEffect, useState} from 'react';
import {LlavesPorEstado} from '../widgets/LlavesPorEstado';
import {InfoCard} from '../components/InfoCard';
import {useEstadisticasDsKey} from '../hooks/useEstadisticasDsKey';
import {EstadisticasLlave} from '../../bussines/entities/EstadisticasLlave.entity';
import {CardLlavesAnuladas} from '../widgets/CardLlavesAnuladas';
import {CardLlavesPorVencer} from '../widgets/CardLlavesPorVencer';
export const DsKeyScreen: React.FC<{}> = ({}) => {
   const today = new Date();
   const {getEstadisticasLlaves} = useEstadisticasDsKey();
   const [estadisticasLlaves, setEstadisticasLlaves] = useState<EstadisticasLlave | null>(null);
   const fetchEstadisticasLlaves = async () => {
      const result = await getEstadisticasLlaves({fecha: today});
      if (result) {
         setEstadisticasLlaves(result);
      }
   };

   useEffect(() => {
      fetchEstadisticasLlaves();
   }, []);

   return (
      <Grid container spacing={2}>
         <Grid item container xs={12} spacing={2}>
            <Grid item sx={{width: '20%'}}>
               <InfoCard
                  descripcion="Total de llaves activas"
                  value={estadisticasLlaves?.totalLlavesActivas || 0}
               />
            </Grid>
            <Grid item sx={{width: '20%'}}>
               <InfoCard
                  descripcion="Nuevas llaves en el mes"
                  value={estadisticasLlaves?.nuevasLlavesMes || 0}
               />
            </Grid>
            <Grid item sx={{width: '20%'}}>
               <CardLlavesAnuladas fecha={today} />
            </Grid>
            <Grid item sx={{width: '20%'}}>
               <CardLlavesPorVencer />
            </Grid>
            <Grid item sx={{width: '20%'}}>
               <InfoCard
                  descripcion="Promedio de llaves por cliente"
                  value={
                     parseFloat((estadisticasLlaves?.promedioLlavesPorCliente ?? 0).toFixed(2)) || 0
                  }
               />
            </Grid>
         </Grid>
         <Grid container item xs={12} spacing={2}>
            <Grid item xs={6}>
               <LlavesPorEstado fecha={today} />
            </Grid>
            <Grid item xs={6}>
               <LlavesPorProducto fecha={today} />
            </Grid>
         </Grid>
      </Grid>
   );
};
